export default __webpack_public_path__ + "static/protectiveConcerned-101c60611123eb88aaff169a3b0c0ab7.svg";